// extracted by mini-css-extract-plugin
export default {"PlanUpgradeButton":"kpncwPgwHsIpEnVRUuCc"};